import { render } from "./commissionDetail.vue?vue&type=template&id=67327bde&scoped=true"
import script from "./commissionDetail.vue?vue&type=script&lang=js"
export * from "./commissionDetail.vue?vue&type=script&lang=js"

import "./commissionDetail.vue?vue&type=style&index=0&id=67327bde&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67327bde"]])

export default __exports__